// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__mwd7W","content":"Consent_content__3YDRi","footer":"Consent_footer__Lbyjh"};